import React from 'react'

import { Theme, Typography } from '@mui/material'
import { makeStyles } from '@mui/styles'

import { IPostElementProps } from '../../../../../types/types'

const InstaHeadline: React.FC<IPostElementProps> = (props) => {
  const useStyles = makeStyles((theme: Theme) => ({
    root: {
      display: 'flex',
      alignItems: 'center',
    },
  }))

  const classes = useStyles()

  return (
    <div className={classes.root}>
      <Typography variant={props.view === 'overview' ? 'h4' : 'h5'}>{props.value}</Typography>
    </div>

  )
}

export default InstaHeadline
